module.exports = __webpack_public_path__ + "assets/img/accountConnectionImg_10.9f816274.png";